import coreUtils from "../../../assets/scripts/core-utils.js";
import jQuery from "jquery";

const $ = jQuery;

const setHeights = () => {

  coreUtils.equalHeights('.image-feature-list-section .equal-height .heading');
  coreUtils.equalHeights('.image-feature-list-section .equal-height .intro');
  coreUtils.equalHeights('.image-feature-list-section .equal-height .link-wrapper');

};

const setIpadHeights = () => {

  coreUtils.equalHeights('.image-feature-list-section .equal-height-ipad .heading');
  coreUtils.equalHeights('.image-feature-list-section .equal-height-ipad .intro');
  coreUtils.equalHeights('.image-feature-list-section .equal-height-ipad .link-wrapper');
  coreUtils.equalHeights('.image-feature-list-section .equal-height-desktop .heading');
  coreUtils.equalHeights('.image-feature-list-section .equal-height-desktop .intro');
  coreUtils.equalHeights('.image-feature-list-section .equal-height-desktop .link-wrapper');

};

const coreImageFeaturelist = (function($) { // eslint-disable-line

  const me = {};

  me.init = () => {

    setTimeout(() => {

      if ($(window).width() <= 1050 && $(window).width() >= 768) {

        setIpadHeights();

      } else if ($(window).width() > 768) {

        setHeights();

      }

    });

    $(window).on('resize', () => {

      if ($(window).width() <= 1050 && $(window).width() >= 768) {

        setIpadHeights();

      } else if ($(window).width() > 768) {

        setHeights();

      }

    });

  };

  return me;

}(jQuery));

export default coreImageFeaturelist;
